import { DateTimePicker, Modal } from '@/components';
import { Button, ButtonOutlined } from '@/components/Button';
import { Input, Select } from '@/components/Inputs';
import { RichTextArea } from '@/components/RichTextArea/RichTextArea';

import { LOCATION_OPTIONS } from '../eventWizard.constants';
import { fromIsoValue, toIsoValue } from '../eventWizard.utils';
import s from '../EventWizardModal.module.scss';

interface ItineraryDetailsModalProps {
  open: boolean;
  eventStart: Date | null;
  eventEnd: Date | null;
  onClose: () => void;
  activity: string;
  onActivityChange: (value: string) => void;
  date: Date | null;
  endDate: Date | null;
  onDatesChange: (start: Date | null, end: Date | null) => void;
  location: string;
  onLocationChange: (value: string) => void;
  notes: string;
  onNotesChange: (value: string) => void;
  onSave: () => void;
}

export function ItineraryDetailsModal({
  open,
  eventStart,
  eventEnd,
  onClose,
  activity,
  onActivityChange,
  date,
  endDate,
  onDatesChange,
  location,
  onLocationChange,
  notes,
  onNotesChange,
  onSave,
}: ItineraryDetailsModalProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <div className={s.taskForm}>
        <span className={s.subSectionTitle}>Add Itinerary Item</span>

        <Input
          label="Activity"
          mandatory
          value={activity}
          onChange={(e) => onActivityChange(e.target.value)}
          placeholder="Sunset drinks on the flybridge"
        />

        <DateTimePicker
          label="Dates"
          placeholder="Choose dates"
          minDate={eventStart ?? undefined}
          maxDate={eventEnd ?? undefined}
          value={toIsoValue(date)}
          endValue={toIsoValue(endDate)}
          onRangeChange={(start, end) => onDatesChange(fromIsoValue(start), fromIsoValue(end))}
        />

        <Select<string>
          label="Location"
          placeholder="None"
          options={[{ label: 'None', value: '' }, ...LOCATION_OPTIONS]}
          value={location}
          onChange={onLocationChange}
        />

        <RichTextArea
          label="Notes"
          value={notes}
          onChange={onNotesChange}
          placeholder="Bring sunscreen and a light jacket"
        />

        <div className={s.taskFormActions}>
          <ButtonOutlined onClick={onClose}>Cancel</ButtonOutlined>
          <Button onClick={onSave} disabled={!activity.trim()}>
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
}
